/**
 *  Created by rlauro on 31.05.2024
 */

/**
 * @enum {{DRAFT: string, FINALIZED: string}}
 */
const AssessmentStatus = {
    DRAFT: 'Draft',
    FINAL: 'Final',
    ALL: 'All'
}

/**
 * Ensures that the value is valid for the AssessmentStatus enum
 * @param value
 * @returns {boolean}
 */
AssessmentStatus.isValid = (value) =>
    value === AssessmentStatus.DRAFT ||
    value === AssessmentStatus.FINAL ||
    value === AssessmentStatus.ALL;


export default AssessmentStatus;
